// extracted by mini-css-extract-plugin
export default {"newproject_continer":"NewProject_newproject_continer__GPdE9"};